import './works.scss'
import { AiOutlineArrowLeft, AiOutlineArrowRight, AiFillHtml5 } from "react-icons/ai";
import { useState } from 'react';
import { GrGithub, GrDeploy } from "react-icons/gr";
import { SiJavascript, SiCss3} from "react-icons/si";

export const Works = () => {

  const [currentSlide, setCurrentSlide]= useState(0);

  const data=[
    {
      id: 1,
      icon:"https://cdn.shopify.com/s/files/1/0248/3473/6191/files/Untitled_2_.png_5_x104@2x.png?v=1620852820",
      title:"BlueFly Clone",
      desc:"BlueFly is a website of daily lifestyle products. In this clone users can view products page, sort them according to need, buy products, make payments, and then checkout.",
      img:"https://user-images.githubusercontent.com/93377428/159107662-f466f72d-f04f-4250-adc0-f32b2f6ce57c.png",
      deploy:"https://blueflyclone-akash.vercel.app/index.html",
      git:"https://github.com/AkashApp/Bluefly_Clone.github.io.git",
      tech:`<SiJavascript/>`,
    },
    {
      id: 2,
      icon:"https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Adidas_Logo.svg/2560px-Adidas_Logo.svg.png",
      title:"Adidas Clone",
      desc:"Adidas clone, web application for purchasing sport collection online. A basic flow of an e-commerce page, where a customer can view and filter products, add the product to cart and place the order.",
      img:"https://user-images.githubusercontent.com/93377428/159107821-e9dbe521-af13-4cd0-b626-ac4c987c53a1.png",
      deploy:"https://rohit753.github.io/Adidas-Clone/index.html",
      git:"https://github.com/rohit753/Adidas-Clone.git",
      tech:`<SiJavascript/>`,
    },
    {
      id: 3,
      icon:"https://www.logo.wine/a/logo/YouTube/YouTube-Icon-Full-Color-Logo.wine.svg",
      title:"Youtube Clone",
      desc:"A YouTube clone made by using HTML, CSS, JS on the basis of API's. On the website user can search any videos and can see the video. user will have all the controll on the video.",
      img:"https://user-images.githubusercontent.com/93377428/159042737-ff438fcd-e368-4f6f-90e9-193388b903c2.png",
      deploy:"https://akashapp.github.io/Youtube_Clone/index.html",
      git:"https://github.com/AkashApp/Youtube_Clone.git",
      tech:`<SiJavascript/>`,
    },
    {
      id: 4,
      icon:"https://icon-library.com/images/movie-icon-png/movie-icon-png-18.jpg",
      title:"Movies Website",
      desc:"A Movies website made by use of HTML, CSS, JS, API's. User can see all the popular movies details, user can search whatever movie they want to and get the details of that movie.",
      img:"https://user-images.githubusercontent.com/93377428/159042546-f7923c89-e036-4f7d-ab63-97615f19ebb0.png",
      deploy:"https://akashapp.github.io/Any_Movies/index.html",
      git:"https://github.com/AkashApp/Any_Movies.git",
      tech:`<SiJavascript/>`,
    },
  ];

  const handleClick= (way)=>{
    way === "left" ? setCurrentSlide(currentSlide > 0 ? currentSlide-1 : data.length-1):
    setCurrentSlide(currentSlide < data.length-1 ? currentSlide + 1 : 0);
  };

  return (
    <div className="works" id="works">
      <h2 className="heading">Projects</h2>
      <div className="slider" style={{transform: `translateX(-${currentSlide * 100}vw)`}}>
        {data.map((d)=>(
        <div className="container">
          <div className="item">
            <div className="left">
              <div className="leftContainer">
                <div className="imgContainer">
                  <img src={d.icon} alt="" />
                </div>
                <h2>{d.title}</h2>
                <p>{d.desc}</p>
                <span>Tech Stack:- <SiJavascript/><AiFillHtml5/><SiCss3/></span>
                <span><a href={d.git} target="_blank" rel="noreferrer"><GrGithub/></a> <a href={d.deploy} target="_blank" rel="noreferrer"><GrDeploy/></a></span>
              </div>
            </div>
            <div className="right">
              <img src={d.img} alt="Website_Image" />
            </div>
          </div>
        </div>
        ))}
        {/* <div className="container">
          <div className="item">
            <div className="left">
              <div className="leftContainer">
                <div className="imgContainer">
                  <img src={d.icon} alt="" />
                </div>
                <h2>{d.title}</h2>
                <p>{d.desc}</p>
                  <span><a href={d.git} target="_blank" rel="noreferrer"><GrGithub/></a> <a href={d.deploy} target="_blank" rel="noreferrer"><GrDeploy/></a></span>
            </div>
            </div>
            <div className="right">
              <img src={d.img} alt="" />
            </div>
          </div>
        </div> */}
      </div>
      <AiOutlineArrowLeft className="arrow left" onClick={()=>handleClick("left")}/>
      <AiOutlineArrowRight className="arrow right" onClick={()=>handleClick()}/>
    </div>
  )
}
